import {
  CONVERSATION_FACTS_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS,
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  MEETINGS_USERS_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const PlaybookPeopleChatQuery: CubeQuery = {
  name: 'PlaybookPeopleChat',
  queryName: 'PlaybookPeopleChat',
  query: {
    dimensions: [
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.HAS_EMAIL_CAPTURED,
      CONVERSATION_FACTS_DIMENSIONS.HAS_MEETING_BOOKED,
      CONVERSATION_FACTS_DIMENSIONS.END_USER_INTERACCTION_MESSAGE_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_AT,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_UPDATED_AT,
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_NAME,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_EMPLOYMENT_TITLE,
    ],
  },
}

export const PlaybookPeopleChatClickedQuery: CubeQuery = {
  name: 'PlaybookPeopleChatClicked',
  queryName: 'PlaybookPeopleChatClicked',
  query: {
    dimensions: [
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.PLAYBOOK_ID,
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.CONVERSATION_ID,
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.CLICKED_AT,
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.HAS_CLICKED,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_EMPLOYMENT_TITLE,
    ],
  },
}
